export { default as InputAdornment } from '@material-ui/core/InputAdornment'
